export default {
  codeType: '',
  codeImageUrl: '',
  codeNumber: '',
  currentTier: 0,
  currentBalance: 0,
  nextTierBalance: 0,
  currentTierCopy: '',
  nextTierCopy: '',
  mainMembershipCardCopy: '',
  isClubCardDrawerOpen: false,
  failedToLoad: false,
}
